<div class="confirm-dialog-overlay" *ngIf="dialogVisible">
  <div class="confirm-dialog">
    <h2>{{ dialogTitle }}</h2>
    <p>{{ dialogMessage }}</p>

    <div class="dialog-actions">
      <button
        [ngClass]="getButtonClass()"
        type="button"
        (click)="onConfirm()"
      >
        Подтвердить
      </button>
      <button class="cancel-button" type="button" (click)="onCancel()">
        Отменить
      </button>
    </div>
  </div>
</div>
